const commentItems = [
  {
    id: 1,
    name: '漫画迷小C',
    avatar: 'C',
    color: 'bg-primary-500',
    time: '2小时前',
    content: '在这个平台追韩漫真的超方便！更新速度快，画质清晰，下拉式阅读体验感拉满。最近在追的《剑与魔法》每天准时更新，太幸福了～',
    likes: '1.2k',
    tag: '忠实用户',
  },
  {
    id: 2,
    name: '追更达人阿K',
    avatar: 'K',
    color: 'bg-accent-500',
    time: '5小时前',
    content: '作为看了五年韩漫的老读者，这个韩国漫画网站大全真的帮了大忙。不用再到处找资源，一个入口就能看到全网热门韩漫，分类也特别清晰。',
    likes: '856',
    tag: '资深读者',
  },
  {
    id: 3,
    name: '新入坑小Z',
    avatar: 'Z',
    color: 'bg-secondary-500',
    time: '昨天',
    content: '刚入坑韩漫一个月，朋友推荐了这个网站。分类索引太贴心了，从恋爱到奇幻各种类型都有，入门指南帮了我大忙，已经推荐给身边的朋友了！',
    likes: '623',
    tag: '新晋读者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            读者评价
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            来自真实韩漫爱好者的使用反馈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-[1000px] mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 flex items-center justify-center rounded-full ${item.color} text-background-50 font-bold text-sm flex-shrink-0`}>
                  {item.avatar}
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <p className="font-medium text-sm text-foreground-900 whitespace-nowrap">{item.name}</p>
                    <span className="inline-flex px-2 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-medium rounded-full whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-4 text-foreground-500">
                <button className="flex items-center gap-1.5 text-xs hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes}</span>
                </button>
                <button className="flex items-center gap-1.5 text-xs hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-3-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}